import { Box, Drawer, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import React, { useCallback, useState } from "react";
import Iconify from "src/components/iconify";
import { PageInfoCloseContext } from "src/components/page-info-carousel";

type PageHeaderProps = {
  title: React.ReactNode,
  subtitle?: React.ReactNode,
  // instructions on how and when to use the page, shown in a side panel behind
  // the blue info button at the far right of the header row
  info?: React.ReactNode,
  tag?: React.ReactNode,
  children?: React.ReactNode,
  noMarginBottom?: boolean
}

export default function PageHeader({ title, subtitle, info, children, tag, noMarginBottom = false }: PageHeaderProps) {
  const [infoOpen, setInfoOpen] = useState(false);
  const closeInfo = useCallback(() => setInfoOpen(false), []);

  return <Box sx={noMarginBottom ? {} : { mb: 2 }}>
    <Stack direction={{ md: "row" }} alignItems="center">
      <Box sx={{ flexGrow: 1, display: "flex", direction: "row", gap: 1, flexWrap: "wrap" }}>
        <Box display="inline-block">
          <Typography variant="h4">
            {title}
          </Typography>
          {subtitle}
        </Box>


        <Box sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center"
        }}>
          {tag}
        </Box>
      </Box>

      {
        (children || info) && <Box sx={{ flexShrink: 0, flexDirection: { xs: "column", md: "row" }, alignItems: "center" }} display="flex" flexWrap="wrap" gap={1} width={{ xs: "100%", md: "initial" }}>
          {children}
          {info &&
            <Tooltip title="How to use this page">
              <IconButton onClick={() => setInfoOpen(true)}>
                <Iconify icon="solar:info-circle-outline" width={24} sx={{ color: "info.main" }} />
              </IconButton>
            </Tooltip>}
        </Box>
      }
    </Stack >

    {info &&
      <Drawer anchor="right" open={infoOpen} onClose={() => setInfoOpen(false)}>
        <Box sx={{ width: { xs: "100vw", sm: 420 }, p: 3, height: "100%", display: "flex", flexDirection: "column" }}>
          <Stack direction="row" alignItems="center" sx={{ mb: 2, flexShrink: 0 }}>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              {title}
            </Typography>
            <IconButton onClick={() => setInfoOpen(false)}>
              <Iconify icon="eva:close-fill" />
            </IconButton>
          </Stack>
          <Box sx={{ flexGrow: 1, minHeight: 0 }}>
            <PageInfoCloseContext.Provider value={closeInfo}>
              {info}
            </PageInfoCloseContext.Provider>
          </Box>
        </Box>
      </Drawer>}
  </Box >
}